<template>
  <v-form
    v-if="lldTestStatus"
    ref="lldDiagnostic"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        row
        wrap>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="testStatus"
            :label="`${ $t('Test Status') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="testType"
            :label="typeLabel"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs6
          md6
          lg6>
          <v-text-field
            v-model="testResult"
            :label="`${ $t('Test Results') }`"
            rows="1"
            readonly/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        row
        wrap>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="startTime"
            :label="`${ $t('Start Time') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="runningTime"
            :label="`${ $t('Running Time') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="remainingTime"
            :label="`${ $t('Estimated Remaining Time') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2/>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.currentCycle"
            :label="`${ $t('Executed Cycles') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="timeToNextSequence"
            :label="`${ $t('Next Sequence in') }`"
            class="dover-input"
            readonly/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        row
        wrap>
        <v-flex
          xs2
          md2
          lg2
          align-center>
          <v-card
            color="dover-blue"
            style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
            dark>
            <v-icon
              v-if="lldTestStatus.pressureRising"
              size="56">mdi-chevron-double-up</v-icon>
            <v-icon
              v-else
              size="56">mdi-chevron-double-down</v-icon>
          </v-card>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="referencePressure"
            :label="`${ $t('Reference Pressure (psi)') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="runningPressure"
            :label="`${ $t('Running Pressure (psi)') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="estimatedLeak"
            :label="leakRateLabel"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="leakRateDelta"
            :label="leakRateDeltaLabel"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.pressurizeRetries"
            :label="`${ $t('Pressurize Retries') }`"
            class="dover-input"
            readonly/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        row
        wrap>
        <v-flex
          xs6
          md6
          lg6>
          <span>
            {{ $t('First Sample') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs6
          md6
          lg6>
          <span>
            {{ $t('Last Sample') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="firstSampleTime"
            :label="`${ $t('Time') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="firstSamplePressure"
            :label="`${ $t('Pressure (psi)') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="lastSampleTime"
            :label="`${ $t('Time') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs3
          md3
          lg3>
          <v-text-field
            v-model="lastSamplePressure"
            :label="`${ $t('Pressure (psi)') }`"
            class="dover-input"
            readonly/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        row
        wrap>
        <v-flex
          xs2
          md12
          lg12>
          <span>
            {{ $t('Factors') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.factorKa"
            :label="`${ $t('Ka') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.factorKb"
            :label="`${ $t('Kb') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.factorKc"
            :label="`${ $t('Kc') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2/>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.factorTauHat"
            :label="`${ $t('Tau Hat') }`"
            class="dover-input"
            readonly/>
        </v-flex>
        <v-flex
          xs2
          md2
          lg2>
          <v-text-field
            v-model="lldTestStatus.factorLrHat"
            :label="`${ $t('Lr Hat') }`"
            class="dover-input"
            readonly/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

export default {
  props: {
    lldTestStatus: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    leakRateLabel: 'Leak Rate',
    leakRateDeltaLabel: 'Leak Rate Delta',
    typeLabel: 'Type'
  }),
  computed: {
    estimatedLeak () {
      return (this.lldTestStatus !== undefined ? this.convertLeakRate(this.lldTestStatus.leakRate) : '0.000')
    },
    firstSampleTime () {
      return this.Maglink.GetCustomTime(this.lldTestStatus !== undefined ? this.lldTestStatus.firstSample.measuredOn : 0)
    },
    firstSamplePressure () {
      return (this.lldTestStatus !== undefined ? this.getFormattedPressure(this.lldTestStatus.firstSample.pressure) : '0.00')
    },
    lastSampleTime () {
      return this.Maglink.GetCustomTime(this.lldTestStatus !== undefined ? this.lldTestStatus.lastSample.measuredOn : 0)
    },
    lastSamplePressure () {
      return (this.lldTestStatus !== undefined ? this.getFormattedPressure(this.lldTestStatus.lastSample.pressure) : '0.00')
    },
    leakRateDelta () {
      return (this.lldTestStatus !== undefined ? this.convertLeakRate(this.lldTestStatus.leakRateDt) : '0.00')
    },
    referencePressure () {
      return (this.lldTestStatus !== undefined ? this.getFormattedPressure(this.lldTestStatus.referencePressure) : '0.00')
    },
    remainingTime () {
      return this.Maglink.GetCustomTimeFromUTCMs(this.lldTestStatus !== undefined ? this.lldTestStatus.remainingTime : 0)
    },
    runningPressure () {
      return (this.lldTestStatus !== undefined ? this.getFormattedPressure(this.lldTestStatus.runningPressure) : '0.00')
    },
    runningTime () {
      return this.Maglink.GetCustomTimeFromUTCMs(this.lldTestStatus !== undefined ? this.lldTestStatus.elapsedTime : 0)
    },
    startTime () {
      return this.Maglink.GetCustomDateTime(this.lldTestStatus !== undefined ? this.lldTestStatus.initialTime : 0, this.systemSettings.dateFormat)
    },
    status () {
      return this.Maglink.GetStatusInfo(this.lld.lastMeasurement.lineStatus).statusDesc
    },
    testResult () {
      return this.Maglink.GetLeakTestResultInfo(this.lldTestStatus !== undefined ? this.lldTestStatus.result : 0).statusDesc.toUpperCase()
    },
    testStatus () {
      return this.Maglink.GetLeakTestStatusInfo(this.lldTestStatus !== undefined ? this.lldTestStatus.state : 0).statusDesc.toUpperCase()
    },
    testType () {
      return (this.lldTestStatus !== undefined ? this.convertLeakRate(this.lldTestStatus.userLeakRateThreshold) : '0.0')
    },
    timeToNextSequence () {
      return this.Maglink.GetCustomTimeFromUTCMs(this.lldTestStatus !== undefined ? this.lldTestStatus.timeToNextSequence : 0)
    }
  },
  mounted () {
    let volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.leakRateLabel = this.$t('Leak Rate') + ' (' + volUdm + '/' + this.$t('H').toLowerCase() + ')'
    this.leakRateDeltaLabel = this.$t('Leak Rate Delta') + ' (' + volUdm + '/' + this.$t('H').toLowerCase() + '*' + this.$t('H').toLowerCase() + ')'
    this.typeLabel = this.$t('Type') + ' (' + volUdm + '/' + this.$t('H').toLowerCase() + ')'
  },
  methods: {
    convertLeakRate (value) {
      return this.Maglink.LeakageFormat(this.Maglink.LeakageToDisplay(value, this.systemSettings.volumeUnit))
    },
    getFormattedPressure (pressure) {
      return pressure.toFixed(2)
    },
    snack (color, message) {
      message = this.$t('LLD Status') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
